import { useQuery } from "@tanstack/react-query";
import {
  AssignmentsConfigFormBasicsDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_QUESTIONS_ASSIGNMENT } from "../domain";

import { questionsAssignmentApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_QUESTIONS_ASSIGNMENT_FORMS_BASICS =
  "GET_QUESTIONS_ASSIGNMENT_FORMS_BASICS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getQuestionsAssignmentFormsBasics = async (): Promise<
  AssignmentsConfigFormBasicsDto[]
> => {
  const response =
    await questionsAssignmentApi.assignmentsConfigControllerGetFormsBasics();

  return response.data;
};

export const useGetQuestionsAssignmentFormsBasics = (
  user: UserProfileDto | null,
): {
  questionsAssignmentFormsBasics?: AssignmentsConfigFormBasicsDto[];
  questionsAssignmentFormsBasicsEnabled: boolean;
  isPendingGetQuestionsAssignmentFormsBasics: boolean;
  isLoadingGetQuestionsAssignmentFormsBasics: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isPending, data, isLoading } = useQuery({
    queryKey: [
      DOMAIN_QUESTIONS_ASSIGNMENT,
      ACTION_GET_QUESTIONS_ASSIGNMENT_FORMS_BASICS,
    ],
    queryFn: () => getQuestionsAssignmentFormsBasics(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    questionsAssignmentFormsBasics: data,
    questionsAssignmentFormsBasicsEnabled: enabled,
    isPendingGetQuestionsAssignmentFormsBasics: isPending,
    isLoadingGetQuestionsAssignmentFormsBasics: isLoading,
  };
};
